import { IMG_BG_CLASS_NAME } from '../../../components/Section/constants';
import ImageHelper from '../../helpers/image';
import dom from '../../wrapper/DomWrapper';

class Section {
  constructor(elSection) {
    this.elSection = elSection;
    this.imgBg = null;
  }

  init = () => {
    this.initBackground();
  };

  initBackground = () => {
    const el = dom.getElement(`.section_bg .${IMG_BG_CLASS_NAME}`, this.elSection);

    if (!el) return;

    this.imgBg = new ImageHelper(el);
    this.imgBg.init();
  };
}

export default Section;
